var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBaseWhite = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 14,
    viewBox: "0 0 54 14",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2472_152031)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.283 6.94c0 3.831-3.203 6.938-7.154 6.938-3.748 0-6.824-2.796-7.129-6.356h9.456V6.356H0C.305 2.796 3.38 0 7.13 0c3.95 0 7.153 3.107 7.153 6.94Zm26.523 5.68c2.479 0 4.105-1.297 4.105-3.252 0-1.815-1.224-2.675-3.075-2.972l-1.642-.266c-1.255-.203-2.092-.735-2.092-1.908 0-1.189.934-2.096 2.704-2.096 1.723 0 2.608.845 2.704 2.05h1.24c-.097-1.596-1.352-3.02-3.928-3.02-2.543 0-3.944 1.393-3.944 3.113 0 1.83 1.272 2.675 3.01 2.956l1.659.25c1.384.235 2.157.782 2.157 1.94 0 1.36-1.143 2.236-2.882 2.236-1.803 0-2.93-.844-3.026-2.283h-1.223c.096 1.877 1.577 3.253 4.233 3.253Zm-18.275-.218h-4.507V1.392h4.346c1.916 0 3.252 1.094 3.252 2.846 0 1.267-.74 2.111-1.932 2.393v.047c1.417.266 2.286 1.204 2.286 2.674 0 1.893-1.433 3.05-3.445 3.05Zm-.322-6.178c1.369 0 2.206-.72 2.206-1.846v-.156c0-1.126-.837-1.83-2.206-1.83h-2.978v3.832h2.978Zm.145 5.177c1.497 0 2.415-.798 2.415-2.018v-.156c0-1.267-.934-2.033-2.43-2.033H19.23V11.4h3.123Zm13.371 1.001h-1.288l-.965-2.987h-4.508L28 12.402h-1.224l3.719-11.01h1.464l3.767 11.01Zm-4.443-9.807h-.096l-1.9 5.834h3.88l-1.884-5.834Zm15.442 9.807V1.392H54v1.016h-6.069v3.785h5.586v1h-5.586v4.192H54v1.017h-7.276Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2472_152031"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h54v14H0z"
  })))));
};
export default SvgBaseWhite;